import propOr from 'ramda/src/propOr';

export default propOr( false, 'tamProxy' );